import { randomNumber } from '../../../../utilities/randomNumber.util'
import { LabsConstants } from './labs.constants'
import { ILabsAction, ILabsState } from './labs.types'

export const initialLabsState: ILabsState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  assessedBy: null,
  rolePerforming: null,
  rolePerformingPNNV: null,
  attempts: '1',
  successfulAttempt: true,
  ABG_ACCESS: null,
  ACTC: '',
  ACTK: '',
  ALB: '',
  ALCOHOL_BLOOD: '',
  ALCOHOL_BREATH: '',
  ALP: '',
  ALT: '',
  AMYLASE: '',
  ANION_GAP: '',
  APAP: '',
  APHI: '',
  AST: '',
  BANDS: '',
  BASOPHILS: '',
  BE: '',
  BILI: '',
  BNP: '',
  BUN: '',
  CA: '',
  CL: '',
  COHB: '',
  CO2: '',
  CPK: '',
  CPK_MB: '',
  CR: '',
  CRP: '',
  CTNT: '',
  DDIMER: '',
  EGFR: '',
  EOSINOPHILS: '',
  ERYTHROCYTE_MORPHOLOGY: '',
  ERYTHROCYTE_SEDIMENT_RATE: '',
  GGT: '',
  GLU: '',
  HCG_SERUM: '',
  HCG_URINE: '',
  HCO3: '',
  HCT: '',
  HGB: '',
  HS_CRP: '',
  HS_CTNT: '',
  HSTROPONIN: '',
  HS_TROPONIN_UNIT: '',
  ICA: '',
  INR: '',
  K: '',
  LACTATE_ARTERIAL: '',
  LACTATE_VENOUS: '',
  LDH: '',
  LEU: '',
  LIPASE: '',
  LYMPHOCYTES: '',
  MCH: '',
  MCHC: '',
  MCV: '',
  MESA: '',
  MG: '',
  MONOCYTES: '',
  MYOGLOBIN: '',
  NA: '',
  NEUTROPHILS: '',
  NH3: '',
  NH4: '',
  NO3: '',
  OTHER: '',
  OSMOLALITY: '',
  PCO2: '',
  PHB: '',
  PHT: '',
  PH_ABG: '',
  PH_VENOUS: '',
  PLTS: '',
  PO2: '',
  PO4: '',
  PRO: '',
  PT: '',
  pta: false,
  PTH: '',
  PH: '',
  PTT: '',
  RBC: '',
  RDW: '',
  RETICULOCYTE_COUNT: '',
  SAT: '',
  SG: '',
  SVO2: '',
  TBILI: '',
  TCO2: '',
  TROPONIN: '',
  WBC_DIFF: '',
  WBC: '',
  procedureComplications: [],
  authorization: null,
  comments: '',
  type: 'Labs',
  isEkgImport: null,
  nemsisCode: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
}

export function labsReducer(state: ILabsState = initialLabsState, action: ILabsAction): ILabsState {
  switch (action.type) {
    case LabsConstants.SET_DATE:
      return { ...state, date: action.date }
    case LabsConstants.SET_TIME:
      return { ...state, time: action.time }
    case LabsConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case LabsConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case LabsConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case LabsConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case LabsConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case LabsConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case LabsConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case LabsConstants.SET_LAB_VALUE:
      return { ...state, [action.labName]: action.value }
    case LabsConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case LabsConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case LabsConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case LabsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case LabsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case LabsConstants.SET_STATE:
      return { ...action.labsState }
    case LabsConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        assessedBy: null,
        rolePerforming: null,
        rolePerformingPNNV: null,
        attempts: '1',
        successfulAttempt: true,
        ABG_ACCESS: null,
        ACTC: '',
        ACTK: '',
        ALB: '',
        ALCOHOL_BLOOD: '',
        ALCOHOL_BREATH: '',
        ALP: '',
        ALT: '',
        AMYLASE: '',
        ANION_GAP: '',
        APAP: '',
        APHI: '',
        AST: '',
        BANDS: '',
        BASOPHILS: '',
        BE: '',
        BILI: '',
        BNP: '',
        BUN: '',
        CA: '',
        CL: '',
        COHB: '',
        CO2: '',
        CPK: '',
        CPK_MB: '',
        CR: '',
        CRP: '',
        CTNT: '',
        DDIMER: '',
        EGFR: '',
        EOSINOPHILS: '',
        ERYTHROCYTE_MORPHOLOGY: '',
        ERYTHROCYTE_SEDIMENT_RATE: '',
        GGT: '',
        GLU: '',
        HCG_SERUM: '',
        HCG_URINE: '',
        HCO3: '',
        HCT: '',
        HGB: '',
        HS_CRP: '',
        HS_CTNT: '',
        HSTROPONIN: '',
        HS_TROPONIN_UNIT: '',
        ICA: '',
        INR: '',
        K: '',
        LACTATE_ARTERIAL: '',
        LACTATE_VENOUS: '',
        LDH: '',
        LEU: '',
        LIPASE: '',
        LYMPHOCYTES: '',
        MCH: '',
        MCHC: '',
        MCV: '',
        MESA: '',
        MG: '',
        MONOCYTES: '',
        MYOGLOBIN: '',
        NA: '',
        NEUTROPHILS: '',
        NH3: '',
        NH4: '',
        NO3: '',
        OTHER: '',
        OSMOLALITY: '',
        PCO2: '',
        PHB: '',
        PHT: '',
        PH_ABG: '',
        PH_VENOUS: '',
        PLTS: '',
        PO2: '',
        PO4: '',
        PRO: '',
        PT: '',
        pta: false,
        PTH: '',
        PH: '',
        PTT: '',
        RBC: '',
        RDW: '',
        RETICULOCYTE_COUNT: '',
        SAT: '',
        SG: '',
        SVO2: '',
        TBILI: '',
        TCO2: '',
        TROPONIN: '',
        WBC_DIFF: '',
        WBC: '',
        procedureComplications: [],
        authorization: null,
        comments: '',
        type: 'Labs',
        isEkgImport: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
